const topicFaqRoot = document.querySelector('.c-topic-faq');

if (topicFaqRoot) {
	const topicButtons = topicFaqRoot.querySelectorAll('.c-topic-faq__topic');
	const faqContainers = topicFaqRoot.querySelectorAll('.c-topic-faq__faqs');

	const plusSVG = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 4V16M4 10H16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
	const minusSVG = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 10H16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

	// Switch topic function
	const switchTopic = (activeTopic) => {
		faqContainers.forEach(container => {
			const containerTopic = container.getAttribute('data-topic');
			container.hidden = containerTopic !== activeTopic;
		});
	};

	// Initialize first topic
	const firstTopic = topicButtons[0]?.getAttribute('data-topic');
	if (firstTopic) {
		switchTopic(firstTopic);
	}

	// Topic button click handlers
	topicButtons.forEach(button => {
		button.addEventListener('click', () => {
			const selectedTopic = button.getAttribute('data-topic');

			topicButtons.forEach(btn => {
				btn.classList.remove('is-active');
				btn.setAttribute('aria-pressed', 'false');
			});

			button.classList.add('is-active');
			button.setAttribute('aria-pressed', 'true');

			switchTopic(selectedTopic);
		});
	});

	// Accordion functionality
	faqContainers.forEach(container => {
		const items = container.querySelectorAll('.c-topic-faq__item');

		items.forEach(item => {
			const question = item.querySelector('.c-topic-faq__question');
			const answer = item.querySelector('.c-topic-faq__answer');
			const icon = item.querySelector('.c-topic-faq__icon');

			if (!question || !answer || !icon) return;

			// Initialize accordion state
			item.classList.remove('is-open');
			question.setAttribute('aria-expanded', 'false');
			answer.setAttribute('aria-hidden', 'true');
			icon.innerHTML = plusSVG;

			// Question click handler
			question.addEventListener('click', () => {
				const isOpen = item.classList.toggle('is-open');
				question.setAttribute('aria-expanded', String(isOpen));
				answer.setAttribute('aria-hidden', String(!isOpen));
				icon.innerHTML = isOpen ? minusSVG : plusSVG;
			});
		});
	});
}
